<template>
  <oxd-input-field
    v-model="internalValue"
    type="autocomplete"
    :clear="false"
    :disabled="disabled"
    :label="label"
    :create-options="loadTimezones"
  >
    <template #option="{data}">
      <span>{{ data.label }}</span>
    </template>
  </oxd-input-field>
</template>

<script>
import {APIService} from '@ohrm/core/util/services/api.service';
import {ref, watch} from 'vue';

export default {
  name: 'TimezoneAutocomplete',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const internalValue = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (val) => {
        internalValue.value = val;
      },
    );

    watch(internalValue, (val) => {
      emit('update:modelValue', val);
    });

    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/attendance/timezones',
    );

    const loadTimezones = async (searchParam) => {
      if (!searchParam.trim()) return [];
      const {data} = await http.getAll({
        timezoneName: searchParam.trim(),
      });

      return data.data.map((timezone) => ({
        id: timezone.name,
        label: `(UTC${timezone.label}) ${timezone.name}`,
        _offset: parseFloat(timezone.offset),
      }));
    };
    return {
      internalValue,
      loadTimezones,
    };
  },
};
</script>
